const n = typeof window < "u" && process.env.CI === "true" ? "/mho/" : "", o = async (e) => fetch(`${n}${e}`), s = async (e, t) => fetch(e, {
  method: "PUT",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify(t)
}), c = async (e, t) => fetch(e, {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  ...t !== void 0 && { body: JSON.stringify(t) }
}), r = async (e) => fetch(e, {
  method: "DELETE",
  headers: {
    "Content-Type": "application/json"
  }
}), a = {
  get: o,
  put: s,
  post: c,
  delete: r
};
export {
  a
};
